import app from 'general/js/app';
import { TAGGED_VIDEOS_URL } from '../../../general/js/api/endeavor/constants/api-constants';

export const livePlayerClassExtensions = Object.freeze({
    CELL: '__cell',
    PLAYER_CELL: '__player-cell',
    R2HLINK: '__r2h-link',
    IS_CLICKABLE: '__is-clickable',
    IS_HOVER: 'is-hover',
    IS_ACTIVE: 'is-active'
});

export const livePlayerCellTypes = Object.freeze({
    HOLE_CELL: 1,
    PLAYER_CELL: 2
});

export const playerStatusCodes = Object.freeze({
    ACTIVE: 1,
    CUT: 2,
    WD: 3,
    RTD: 4,
    DQ: 5,
    DNS: 6
});

export const playerSitecoreData = {
    firstName: '',
    lastName: '',
    cutoutSrc: '',
    status: 1
};

export const navTabs = (tabs) => {
    return [
        {
            id: 'score',
            text: tabs.scoreTabText ? tabs.scoreTabText : 'Score',
        },
        {
            id: 'highlights',
            text: tabs.highlightsTabText ? tabs.highlightsTabText : 'Highlights',
        },
        {
            id: 'news',
            text: tabs.newsTabText ? tabs.newsTabText : 'Latest News',
        }
    ];
};
export const latestNewsNavTabs = (tabs) => {
    return [
        {
            id: 'videos',
            text: tabs.videosTabText ? tabs.videosTabText : 'Videos',
        },
        {
            id: 'articles',
            text: tabs.articlesTabText ? tabs.articlesTabText : 'Articles',
        }
    ];
};


export const getEndeavorUrl = (tags, pageSize = 25) => {
    const params = new URLSearchParams();
    tags.forEach((tag) => {
        params.append('tag', tag);
    });
    params.append('rpp', pageSize);
    return `${TAGGED_VIDEOS_URL}?${params.toString()}`;
};

export const PLAYER_ID_QS_NAME = 'popupPlayerId';
export const LCQ_QS_NAME = 'lcq';

export const getPlayerExternalLink = (url, id) => {
    return `${url}?${PLAYER_ID_QS_NAME}=${id}`;
};

export const CHAMPION_CHOICE_ID = '0';
export const HIGHLIGHTS_INTERVAL_SEC = '60';

export const getPreviousRoundsIds = (currentRound) => {
    if (!currentRound) return [];

    switch (currentRound.toString()) {
        case '2':
            return ['1'];
        case '3':
            return ['1', '2'];
        case '4':
        case '401':
            return ['1', '2', '3'];
        default:
            return [];
    }
};

export const GetWebsiteContextMetaDataObject = (isWomensOpenWebsiteContext, firstName, lastName) => {
    if (isWomensOpenWebsiteContext) {
        return ({
            highlight: 'yes',
            wopersonofinterest: `${firstName} ${lastName}`,
            year: app.state.serverYear,
        });
    }
    return ({
        highlight: 'yes',
        personofinterest: `${firstName} ${lastName}`,
        year: app.state.serverYear,
    });
};

export const THEOPEN_EVENT_TAG = 'Open';
export const AIGWO_EVENT_TAG = 'AIGWO';
export const HIGHLIGHTS_TAG = 'highlights';
export const TEE_TIMES_SCORECARD_TITLE = 'Tee Times Scorecard - ';
export const TEE_TIMES_WIDGET_SCORECARD_TITLE = 'Tee Times Widget Scorecard - ';
export const LEADERBOARD_SCORECARD_TITLE = 'Leaderboard Scorecard - ';
export const LEADERBOARD_WIDGET_SCORECARD_TITLE = 'Leaderboard Widget Scorecard - ';
